import { Skeleton } from '@crehana/compass.ui/v3/skeleton';

const KPI_CARD_SKELETON_KEYS = ['card-1', 'card-2', 'card-3', 'card-4'];

// Mirrors the prototype block sizes while the first response for the current
// period resolves. Every size maps to the project spacing scale except the
// table block: the scale stops at 28.8rem, so 32rem has no equivalent.
export const ComplianceLoadingSkeleton = () => {
  return (
    <div className="tw-flex tw-flex-col tw-cds-gap-6">
      <Skeleton.Block className="tw-h-3.2 tw-w-24" />

      <div className="tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-cds-gap-5">
        {KPI_CARD_SKELETON_KEYS.map(key => (
          <div
            key={key}
            className="tw-flex tw-h-9.6 tw-items-center tw-border tw-border-solid tw-cds-border-color-default tw-cds-rounded-m tw-cds-p-5"
          >
            <Skeleton.Block className="tw-h-2.8 tw-w-6" />
          </div>
        ))}
      </div>

      <Skeleton.Block className="tw-h-[32rem]" />
    </div>
  );
};
